export const colors = {
    light: 'light',
    strong: 'strong',
};
export const types = {
    centered: 'centered',
    indented: 'indented',
    standard: 'standard',
};
